import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { projectMenuApiErrorCodeOptions } from '../constants'
import { useSnackbar } from '../../../components/stories/molecules/snackbar/component/snackbar-hook'
import { snackbarVariantOptions } from '../../../components/stories/molecules/snackbar/constants'
import { useCreateFolderMutation } from '../../../react-query/project/mutation/use-create-folder-mutation'
import CreateFolderModal from '../../../components/create-folder-modal'
import { useProjectMenuListViewControl } from '../../../hooks/use-project-menu-list-view-control'

const CreateFolderModalWrapper = () => {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const { addSnackbar } = useSnackbar()

  const { parentId: defaultFolderId } = useParams()
  const [folderCreationError, setFolderCreationError] = useState(null)
  const [folderNameHint, setFolderNameHint] = useState(null)

  const { viewType, tab } = useProjectMenuListViewControl()

  const showSnackbarSuccess = () => {
    addSnackbar({
      message: formatMessage({ id: 'projectMenu_folder_created' }),
      snackbarType: snackbarVariantOptions.SUCCESS,
      hideCloseButton: true
    })
  }

  const handleOnClose = () => {
    history.push(`/project?view=${viewType}&tab=${tab}`)
  }

  const handleFolderCreationError = (error) => {
    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.NO_PERMISSION_TO_CREATE_PROJECT_OR_FOLDER
    ) {
      return setFolderCreationError(
        formatMessage({
          id: 'projectMenu_no_permission_to_create'
        })
      )
    }

    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.FOLDER_NAME_IS_NOT_AVAILABLE
    ) {
      return setFolderNameHint(
        formatMessage({
          id: 'projectMenu_folder_with_this_name_aready_exists'
        })
      )
    }

    if (
      error &&
      error?.response?.data?.status ===
        projectMenuApiErrorCodeOptions.FOLDER_NO_LOGER_EXISTS
    ) {
      return setFolderNameHint(
        formatMessage({
          id: 'recursiveFolderList_the_selected_folder_no_longer_exists'
        })
      )
    }

    return setFolderCreationError(
      formatMessage({
        id: 'projectMenu_project_create_error'
      })
    )
  }

  const handleFolderCreated = () => {
    handleOnClose()
    showSnackbarSuccess()
  }

  // Mutations
  const { mutate: createFolder, isPending: createFolderLoading } =
    useCreateFolderMutation({
      onSuccess: handleFolderCreated,
      onError: handleFolderCreationError
    })

  // handlers

  const handleCreateFolder = ({ folderName, parentFolderId }) => {
    setFolderCreationError(null)
    setFolderNameHint(null)
    createFolder({
      folderName,
      parentFolderId
    })
  }

  return (
    <CreateFolderModal
      handleCreate={handleCreateFolder}
      handleClose={handleOnClose}
      createFolderError={folderCreationError}
      createFolderLoading={createFolderLoading}
      isLoading={false}
      defaultFolderId={defaultFolderId}
      folderNameHintMessage={folderNameHint}
    />
  )
}

export default CreateFolderModalWrapper
